"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchNativeEvent = exports.dispatchUpdatedChange = exports.dispatchOnInput = exports.dispatchOnChange = void 0;

const setNativeValue = (element, value) => {
  const {
    set: valueSetter
  } = Object.getOwnPropertyDescriptor(element, 'value') || {};
  const prototype = Object.getPrototypeOf(element);
  const {
    set: prototypeValueSetter
  } = Object.getOwnPropertyDescriptor(prototype, 'value') || {};

  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else if (valueSetter) {
    valueSetter.call(element, value);
  } else {
    throw new Error('The given element does not have a value setter');
  }
};

const dispatchOnChange = (element, value) => {
  setNativeValue(element, value);
  const event = new Event('change', {
    bubbles: true,
    cancelable: false
  });
  element.dispatchEvent(event);
};

exports.dispatchOnChange = dispatchOnChange;

const dispatchOnInput = (element, value) => {
  setNativeValue(element, value);
  const event = new Event('input', {
    bubbles: true,
    cancelable: false
  });
  element.dispatchEvent(event);
};

exports.dispatchOnInput = dispatchOnInput;

const dispatchUpdatedChange = (event, value, callback) => {
  const updatedEvent = { ...event,
    target: { ...event.target,
      value
    }
  };
  callback == null ? void 0 : callback(updatedEvent);
};

exports.dispatchUpdatedChange = dispatchUpdatedChange;

const dispatchNativeEvent = (event, callback) => {
  if (typeof event.persist === 'function') event.persist();
  callback == null ? void 0 : callback(event);
};

exports.dispatchNativeEvent = dispatchNativeEvent;